//import Global from '../shared/global';

const $ = jQuery.noConflict();

'use strict';
const productSearch = {

	// prepare dom variables
	$domLoadMoreSpinner: null,
	$domSearchStatus: null,
	$domSearchInput: null,
	$domSearchButton: null,
	$domSubFilterCategory: null,
	$domSubFilterBrand: null,

	// main initialization
	init: function() {
		if (!$('body').hasClass('page-template-page-search-products') && !$('body').hasClass('page-template-page-search-products-by-category')) {
			return;
		}
		this.initDom();
		this.bindEvents();
		this.initTableSorting();
	},


	// initialize dom variables
	initDom: function() {
		productSearch.$domLoadMoreSpinner = $('.js-product-search-spinner');
		productSearch.$domSearchStatus = $('.js-select-status');
		productSearch.$domSearchStatuses = $('.filters-search input[name=statuses]');
		productSearch.$domSearchInput = $('.filters-search input[type=text]');
		productSearch.$domSearchButton = $('.filters-search button');
		productSearch.$domSubFilterCategory = $('#selectCategories');
		productSearch.$domSubFilterBrand = $('#selectBrands');
	},

	// attach event listeners
	bindEvents: function() {
		productSearch.$domSearchInput.on('keyup', function(e) {
			if (e.keyCode === 13) {
				productSearch.onSearchClick();
			}
		});
		productSearch.$domSearchButton.on('click', productSearch.onSearchClick);
		productSearch.$domSubFilterCategory.on('change', productSearch.onChangeCategory);
		productSearch.$domSubFilterBrand.on('change', productSearch.onChangeBrand);
	},

	// handler for click on "Search" button
	onSearchClick: function() {
		const term = productSearch.$domSearchInput.val();
		if (term.length < 3) {
			return;
		}
		const params = {
			term: term,
		};
		if (productSearch.$domSearchStatuses.length) {
			params.statuses = productSearch.$domSearchStatuses.val();
		} else if (productSearch.$domSearchStatus.val() !== '-') {
			params.status = productSearch.$domSearchStatus.val();
		}
		productSearch.redirect(params);
	},

	// initialize sorting arrows in table header cells
	initTableSorting: function() {
		$('#filtersTable thead').on('click', 'th', function() {
			$(this).attr('data-order', ($(this).attr('data-order') === 'desc' ? 'asc' : 'desc'));
			productSearch.onTableHeaderClick(this, $('#filtersTable thead th').index(this), $(this).hasClass('dateTh'));
			const order = $(this).attr('data-order');
			$(this).toggleClass('sort-up', order === 'desc');
			$(this).toggleClass('sort-down', order === 'asc');
		});
	},

	// redirect browser to new URL
	redirect: function(params, status = '') {
		Object.keys(params).forEach(key => {if (!params[key]) delete params[key];}); // remove empty params
		params = $.param(params);
		if (status === 'cat' || status === 'brand') {
			params = productSearch.restartDropdown(params, status);
		}
		document.location.href = document.location.origin + document.location.pathname + '?' + params;
	},

	restartDropdown: (params, status)=>{
		const startIndex = params.indexOf(`&${status}=`);
		let endIndex = params.indexOf('&', startIndex + 1);
		if (endIndex === -1) {
			endIndex = params.length;
		}
		return params.replace(params.substring(startIndex, endIndex), '');
	},

	// handler for clicks on table header cells
	onTableHeaderClick: function(header, index) {
		const tbody = $(header).closest('table').find('tbody');
		const order = $(header).attr('data-order');
		tbody.find('tr').sort(function(a, b) {
			// eslint-disable-next-line
			let tda = $(a).find('td:eq(' + index + ')').text();
			// eslint-disable-next-line
			let tdb = $(b).find('td:eq(' + index + ')').text();
			// eslint-disable-next-line
			return (order === 'asc' ? (tda > tdb ? 1 : tda < tdb ? -1 : 0) : (tda < tdb ? 1 : tda > tdb ? -1 : 0));
		}).appendTo(tbody);
	},

	// handler for changing of Category select
	onChangeCategory: function() {
		const query = window.fwsProductsSearchQuery;
		query.cat = productSearch.$domSubFilterCategory.val();
		let status = '';
		if (query.cat === 'reset') {
			status = 'cat';
		}
		productSearch.redirect(query, status);
	},

	// handler for changing of Brands select
	onChangeBrand: function() {
		const query = window.fwsProductsSearchQuery;
		query.brand = productSearch.$domSubFilterBrand.val();
		let status = '';
		if (query.brand === 'reset') {
			status = 'brand';
		}
		productSearch.redirect(query, status);
	},

};


export default productSearch;
